import Multiselect from "multiselect-react-dropdown";
import { ConfigColumns2 } from "../../types/configColumns2";
import "./DtGrid2DropDown.css";
import React from "react";

export default function DtGrid2Dropown(props: {
    updateFiltersFromDropDown: (
        sortingProperty: string,
        values: {
            cat: string;
            text: string;
            key: string;
        }[]
    ) => void;
    dropDownOptions: {
        cat: string;
        key: any;
        text: any;
    }[];
    column: ConfigColumns2;
    departmentId: number;
}) {
    let ref = React.createRef<Multiselect>();

    React.useEffect(() => {
        if (ref.current) ref.current.resetSelectedValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.departmentId]);

    return (
        <Multiselect
            ref={ref}
            displayValue="text"
            hideSelectedList
            selectedValues={props.column.dropdownSelectAll === true ? props.dropDownOptions : []}
            onKeyPressFn={e => {
                // on press fn event. ignore for now
            }}
            onRemove={e => {
                props.updateFiltersFromDropDown(props.column.data, e);
            }}
            onSearch={e => {
                // on search event. ignore for now
            }}
            onSelect={e => {
                props.updateFiltersFromDropDown(props.column.data, e);
            }}
            // onSelect={function noRefCheck() {}}
            options={props.dropDownOptions}
            showCheckbox
            showArrow
        />
    );
}
